"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _Bearbeiter = _interopRequireDefault(require("./Bearbeiter"));
var _HeaderDaten = _interopRequireDefault(require("./HeaderDaten"));
var _HeaderResponse = _interopRequireDefault(require("./HeaderResponse"));
var _RageRights = _interopRequireDefault(require("./RageRights"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Rage+ API
 * API für das Rage+ / VerseNeo Backend der BLB Shops für Edelmetalle und Sorten
 *
 * The version of the OpenAPI document: 1.0.44
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The LogonClientNext model module.
 * @module model/LogonClientNext
 * @version 1.0.44
 */
var LogonClientNext = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>LogonClientNext</code>.
   * Logindaten für ClientNext
   * @alias module:model/LogonClientNext
   * @implements module:model/HeaderResponse
   * @param header {module:model/HeaderDaten} 
   * @param listRageRights {Array.<module:model/RageRights>} Liste der berechtigten Rollen, die der User hat
   */
  function LogonClientNext(header, listRageRights) {
    _classCallCheck(this, LogonClientNext);
    _HeaderResponse.default.initialize(this, header);
    LogonClientNext.initialize(this, header, listRageRights);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(LogonClientNext, null, [{
    key: "initialize",
    value: function initialize(obj, header, listRageRights) {
      obj['header'] = header;
      obj['listRageRights'] = listRageRights;
    }

    /**
     * Constructs a <code>LogonClientNext</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/LogonClientNext} obj Optional instance to populate.
     * @return {module:model/LogonClientNext} The populated <code>LogonClientNext</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new LogonClientNext();
        _HeaderResponse.default.constructFromObject(data, obj);
        if (data.hasOwnProperty('header')) {
          obj['header'] = _HeaderDaten.default.constructFromObject(data['header']);
        }
        if (data.hasOwnProperty('tokenId')) {
          obj['tokenId'] = _ApiClient.default.convertToType(data['tokenId'], 'String');
        }
        if (data.hasOwnProperty('successUrl')) {
          obj['successUrl'] = _ApiClient.default.convertToType(data['successUrl'], 'String');
        }
        if (data.hasOwnProperty('realm')) {
          obj['realm'] = _ApiClient.default.convertToType(data['realm'], 'String');
        }
        if (data.hasOwnProperty('listRageRights')) {
          obj['listRageRights'] = _ApiClient.default.convertToType(data['listRageRights'], [_RageRights.default]);
        }
        if (data.hasOwnProperty('mitarbeiter')) {
          obj['mitarbeiter'] = _Bearbeiter.default.constructFromObject(data['mitarbeiter']);
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>LogonClientNext</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>LogonClientNext</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // check to make sure all required properties are present in the JSON string
      var _iterator = _createForOfIteratorHelper(LogonClientNext.RequiredProperties),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var property = _step.value;
          if (!data[property]) {
            throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
          }
        }
        // validate the optional field `header`
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (data['header']) {
        // data not null
        _HeaderDaten.default.validateJSON(data['header']);
      }
      // ensure the json data is a string
      if (data['tokenId'] && !(typeof data['tokenId'] === 'string' || data['tokenId'] instanceof String)) {
        throw new Error("Expected the field `tokenId` to be a primitive type in the JSON string but got " + data['tokenId']);
      }
      // ensure the json data is a string
      if (data['successUrl'] && !(typeof data['successUrl'] === 'string' || data['successUrl'] instanceof String)) {
        throw new Error("Expected the field `successUrl` to be a primitive type in the JSON string but got " + data['successUrl']);
      }
      // ensure the json data is a string
      if (data['realm'] && !(typeof data['realm'] === 'string' || data['realm'] instanceof String)) {
        throw new Error("Expected the field `realm` to be a primitive type in the JSON string but got " + data['realm']);
      }
      // ensure the json data is an array
      if (!Array.isArray(data['listRageRights'])) {
        throw new Error("Expected the field `listRageRights` to be an array in the JSON data but got " + data['listRageRights']);
      }
      // validate the optional field `mitarbeiter`
      if (data['mitarbeiter']) {
        // data not null
        _Bearbeiter.default.validateJSON(data['mitarbeiter']);
      }
      return true;
    }
  }]);
}();
LogonClientNext.RequiredProperties = ["header", "listRageRights"];

/**
 * @member {module:model/HeaderDaten} header
 */
LogonClientNext.prototype['header'] = undefined;

/**
 * ID für Connection Token
 * @member {String} tokenId
 */
LogonClientNext.prototype['tokenId'] = undefined;

/**
 * Weiterlietungs-Url
 * @member {String} successUrl
 */
LogonClientNext.prototype['successUrl'] = undefined;

/**
 * Bereich teil der Url
 * @member {String} realm
 */
LogonClientNext.prototype['realm'] = undefined;

/**
 * Liste der berechtigten Rollen, die der User hat
 * @member {Array.<module:model/RageRights>} listRageRights
 */
LogonClientNext.prototype['listRageRights'] = undefined;

/**
 * @member {module:model/Bearbeiter} mitarbeiter
 */
LogonClientNext.prototype['mitarbeiter'] = undefined;

// Implement HeaderResponse interface:
/**
 * @member {module:model/HeaderDaten} header
 */
_HeaderResponse.default.prototype['header'] = undefined;
var _default = exports.default = LogonClientNext;